/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2019 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($, Drupal) {

   Drupal.behaviors.sectionNav = {
    attach: function (context) {
      'use strict';

      $(document).ready(function () {

        // Trigger the mobile section nav dropdown
        $('.section-nav__mobile-trigger').click(function () {
          if ($(this).hasClass('is-open')) {
            // Close dropdown if click again
            $(this).removeClass('is-open');
          } else {
            // Open dropdown on click
            $(this).addClass('is-open');
          }
        });

      });

    }
  };
})(jQuery, Drupal);
